export default __webpack_public_path__ + "static/media/supergiant.63ae113a.svg";